export type LineRef = {
  offerItemId: number;
  blockUuid: string | null;
  serviceId: number;
  lineDisc: number;
};
export const lineKey = (r: LineRef): string =>
  `${r.offerItemId}:${r.blockUuid ?? ''}:${r.serviceId}:${r.lineDisc}`;
